module.exports = __webpack_public_path__ + "img/4brice.932e834d.jpg";